<template>
  <div>
    <vs-popup-custom
      :title="$t('departament') | capitalize"
      color="danger"
      :buttonCloseHidden="true"
      :active.sync="value"
      :persistent="true"
    >
      <div :id="loadingPage" class="vs-con-loading__container">
        <form class="px-2">
          <div class="popup-custom-h-200">
            <vs-row class="mb-5">
              <vs-col vs-xs="12" vs-sm="3" vs-lg="3">
                <span>{{ $t('name') | capitalize }}</span>
              </vs-col>
              <vs-col vs-xs="12" vs-sm="9" vs-lg="9">
                <vs-input
                  :placeholder="$t('name') | capitalize"
                  class="w-full"
                  maxlength="120"
                  v-model="form.name"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="center">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-xs="12"
                vs-sm="3"
                vs-lg="3"
              >
                <vs-button
                  class="w-full m-2"
                  type="filled"
                  color="primary"
                  :disabled="disabledSubmit"
                  @click="submit"
                >
                  {{ $t('submit') | capitalize }}
                </vs-button>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-xs="12"
                vs-sm="3"
                vs-lg="3"
              >
                <vs-button
                  class="w-full m-2"
                  type="filled"
                  color="#626262"
                  @click="close"
                >
                  {{ $t('close') | capitalize }}
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </form>
      </div>
    </vs-popup-custom>
  </div>
</template>
  
  <script>
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'

import loading from '@/mixins/Loading'
import request from '../request.js'

export default {
  components: {
    VsPopupCustom,
  },
  computed: {
    disabledSubmit() {
      return this.form.name === ''
    },
  },
  data() {
    return {
      loadingPage: 'departament-modal-loading',
      form: {
        id: '',
        name: '',
      },
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
      this.reset()
    },
    reset() {
      this.form = {
        id: '',
        name: '',
      }
    },
    submit() {
      if (this.item.id === '') {
        this.store()
        return
      }
      this.update()
    },
    store() {
      this.openLoading(this.loadingPage)
      const payload = {
        name: this.form.name.trim(),
      }
      request
        .store(payload)
        .then((response) => {
          this.closeLoading(this.loadingPage)
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Departament Added.',
          })
          this.close()
          this.$emit('refresh')
        })
        .catch((error) => {
          this.closeLoading(this.loadingPage)
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: 'The given data was invalid.',
          })
          this.showValidationErrors(error)
        })
    },
    update() {
      this.openLoading(this.loadingPage)
      const payload = {
        id: this.form.id,
        name: this.form.name.trim(),
      }
      request
        .update(payload)
        .then((response) => {
          this.closeLoading(this.loadingPage)
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Departement Updated',
          })
          this.close()
          this.$emit('refresh')
          
        })
        .catch((response) => {
          this.closeLoading(this.loadingPage)
            this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: 'The given data was invalid.',
          })
          this.showValidationErrors(response)
        })
    },
  },
  mixins: [loading],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.form = this.item
      }
    },
  },
}
</script>
